import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AtlasPanelComponent } from './atlas-panel.component';

/**
 * The eager standalone seam that lazily mounts {@link AtlasPanelComponent}. The Dynamic Panel host is an
 * NgModule component, and a standalone panel listed in that module's `imports` is pulled into the eager
 * shell bundle by the module's own static import — `@defer` in the panel host's template cannot undo that.
 * So the module holds this thin boundary eagerly instead, and the real panel is referenced ONLY inside this
 * standalone component's `@defer`: the panel, the inspector and the Atlas read-stores then split into their
 * own chunk that loads the first time a permitted user opens Atlas in the panel.
 */
@Component({
  selector: 'app-atlas-panel-outlet',
  template: `@defer (on immediate) {
    <app-atlas-panel />
  } @placeholder {
    <div class="h-full" aria-busy="true"></div>
  }`,
  standalone: true,
  imports: [AtlasPanelComponent],
  host: { class: 'block h-full min-h-0' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AtlasPanelOutletComponent {}
